export class AuthenticationData {
    username: string;
    authority: string;

    constructor(username: string, authority: string) {
        this.username = username;
        this.authority = authority;
    }
}

export enum AuthenticationRole {
    ROLE_ADMIN = "ROLE_ADMIN",
    ROLE_ADJUDICATOR = "ROLE_ADJUDICATOR"
}